@file:OptIn(InternalResourceApi::class)

package rainbowclubs.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/rainbowclubs.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(233_596_472)
internal val Res.drawable.ic_add: DrawableResource by lazy {
      DrawableResource("drawable:ic_add", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_add.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_170_337_108)
internal val Res.drawable.ic_admin: DrawableResource by lazy {
      DrawableResource("drawable:ic_admin", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_admin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-286_622_253)
internal val Res.drawable.ic_arrow_back: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_back.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_394_157_183)
internal val Res.drawable.ic_calendar: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-548_490_698)
internal val Res.drawable.ic_cancel: DrawableResource by lazy {
      DrawableResource("drawable:ic_cancel", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cancel.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_975_007_061)
internal val Res.drawable.ic_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-27_694_443)
internal val Res.drawable.ic_chevron_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_chevron_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chevron_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(453_819_638)
internal val Res.drawable.ic_clipboard_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_clipboard_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clipboard_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_862_465_749)
internal val Res.drawable.ic_clock: DrawableResource by lazy {
      DrawableResource("drawable:ic_clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clock.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(47_573_016)
internal val Res.drawable.ic_close: DrawableResource by lazy {
      DrawableResource("drawable:ic_close", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_close.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(835_323_602)
internal val Res.drawable.ic_clubs: DrawableResource by lazy {
      DrawableResource("drawable:ic_clubs", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clubs.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(377_748_534)
internal val Res.drawable.ic_dashboard_grid: DrawableResource by lazy {
      DrawableResource("drawable:ic_dashboard_grid", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dashboard_grid.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(541_175_752)
internal val Res.drawable.ic_delete: DrawableResource by lazy {
      DrawableResource("drawable:ic_delete", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_delete.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_492_362_025)
internal val Res.drawable.ic_document_edit: DrawableResource by lazy {
      DrawableResource("drawable:ic_document_edit", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_document_edit.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_105_633_218)
internal val Res.drawable.ic_home: DrawableResource by lazy {
      DrawableResource("drawable:ic_home", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_095_615_559)
internal val Res.drawable.ic_invitation: DrawableResource by lazy {
      DrawableResource("drawable:ic_invitation", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_invitation.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_640_992_696)
internal val Res.drawable.ic_location: DrawableResource by lazy {
      DrawableResource("drawable:ic_location", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_location.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-133_830_938)
internal val Res.drawable.ic_logout: DrawableResource by lazy {
      DrawableResource("drawable:ic_logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logout.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(478_433_159)
internal val Res.drawable.ic_messages: DrawableResource by lazy {
      DrawableResource("drawable:ic_messages", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_messages.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-416_908_045)
internal val Res.drawable.ic_more: DrawableResource by lazy {
      DrawableResource("drawable:ic_more", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_more.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-798_652_548)
internal val Res.drawable.ic_question_mark: DrawableResource by lazy {
      DrawableResource("drawable:ic_question_mark", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_question_mark.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_854_721_097)
internal val Res.drawable.ic_search: DrawableResource by lazy {
      DrawableResource("drawable:ic_search", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_search.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(584_441_356)
internal val Res.drawable.ic_shield_star: DrawableResource by lazy {
      DrawableResource("drawable:ic_shield_star", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_shield_star.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(645_038_602)
internal val Res.drawable.ic_text_fields: DrawableResource by lazy {
      DrawableResource("drawable:ic_text_fields", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_text_fields.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-164_185_847)
internal val Res.drawable.ic_upload: DrawableResource by lazy {
      DrawableResource("drawable:ic_upload", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_upload.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-696_841_620)
internal val Res.drawable.ic_visible_off: DrawableResource by lazy {
      DrawableResource("drawable:ic_visible_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_visible_off.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-923_068_438)
internal val Res.drawable.ic_visible_on: DrawableResource by lazy {
      DrawableResource("drawable:ic_visible_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_visible_on.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_689_190_128)
internal val Res.drawable.ic_warning: DrawableResource by lazy {
      DrawableResource("drawable:ic_warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_warning.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_798_820_856)
internal val Res.drawable.rainbow_clubs: DrawableResource by lazy {
      DrawableResource("drawable:rainbow_clubs", setOf(
        ResourceItem(setOf(), "${MD}drawable/rainbow_clubs.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_add", Res.drawable.ic_add)
  map.put("ic_admin", Res.drawable.ic_admin)
  map.put("ic_arrow_back", Res.drawable.ic_arrow_back)
  map.put("ic_calendar", Res.drawable.ic_calendar)
  map.put("ic_cancel", Res.drawable.ic_cancel)
  map.put("ic_check", Res.drawable.ic_check)
  map.put("ic_chevron_right", Res.drawable.ic_chevron_right)
  map.put("ic_clipboard_check", Res.drawable.ic_clipboard_check)
  map.put("ic_clock", Res.drawable.ic_clock)
  map.put("ic_close", Res.drawable.ic_close)
  map.put("ic_clubs", Res.drawable.ic_clubs)
  map.put("ic_dashboard_grid", Res.drawable.ic_dashboard_grid)
  map.put("ic_delete", Res.drawable.ic_delete)
  map.put("ic_document_edit", Res.drawable.ic_document_edit)
  map.put("ic_home", Res.drawable.ic_home)
  map.put("ic_invitation", Res.drawable.ic_invitation)
  map.put("ic_location", Res.drawable.ic_location)
  map.put("ic_logout", Res.drawable.ic_logout)
  map.put("ic_messages", Res.drawable.ic_messages)
  map.put("ic_more", Res.drawable.ic_more)
  map.put("ic_question_mark", Res.drawable.ic_question_mark)
  map.put("ic_search", Res.drawable.ic_search)
  map.put("ic_shield_star", Res.drawable.ic_shield_star)
  map.put("ic_text_fields", Res.drawable.ic_text_fields)
  map.put("ic_upload", Res.drawable.ic_upload)
  map.put("ic_visible_off", Res.drawable.ic_visible_off)
  map.put("ic_visible_on", Res.drawable.ic_visible_on)
  map.put("ic_warning", Res.drawable.ic_warning)
  map.put("rainbow_clubs", Res.drawable.rainbow_clubs)
}
